var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline pr-1",style:({ color: _vm.activeColor, fontSize: _vm.fontSize + 'px', opacity: _vm.opacity + '%' })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }